import {initializeApp} from "firebase/app";
import AppConfig from "./appConfig";
import {getFirestore} from "firebase/firestore";
import {getAuth} from "firebase/auth";
import {getMessaging, getToken} from "firebase/messaging";
import axiosApi from "./axiosApi";


const appConfig = new AppConfig();
const app = initializeApp(appConfig.dbCred)
const db = getFirestore(app);
const auth = getAuth(app);

let messaging

try {
    messaging = getMessaging(app);
} catch (e) {
    console.warn('Error getting messaging');
}


const persistToken = (uid, token) => {
    // Persistir token FCM vía backend (evita acceso directo a Firestore)
    axiosApi.post(appConfig.apihostEnv + "/device-tokens-pushn", { uid, token })
        .then(() => {
            console.log('Token persisted');
        })
        .catch(() => {
            console.error('Error guardando credencial');
        });
}

const getTokenAndPersist = (userId) => {
    return new Promise((resolve, reject) => {
        getToken(messaging, {vapidKey: appConfig.cloudMessagingVapidKey}).then((currentToken) => {
            if (currentToken) {
                persistToken(userId, currentToken);
                resolve(currentToken);
            } else {
                console.log('Credencial de registro no disponible');
                reject('No registration token available. Request permission to generate one.');
            }
        }).catch((err) => {
            console.log('Error al obtener credencial');
            reject(err);
        })
    });
}


const setupMessaging = () => {

    setTimeout(() => {
        if (auth.currentUser) {
            getTokenAndPersist(auth.currentUser.uid).then((token) => {
            }).catch((err) => {
                console.error('Error obteniendo credencial');
            });
        }
    }, 5000);


}
/*

if (("Notification" in window)) {
    // Check if the browser supports notifications
    console.log('Notification permission');
    if (Notification.permission === "granted") {
        // Check whether notification permissions have already been granted;
        // if so, create a notification
        setupMessaging();
        // …
    } else if (Notification.permission !== "denied") {
        // We need to ask the user for permission
        Notification.requestPermission().then((permission) => {
            // If the user accepts, let's create a notification
            if (permission === "granted") {
                setupMessaging();
            }
        });
    }
} else {
    console.log('This browser does not support notifications.');
}

 */


export {app, db, auth, messaging, setupMessaging, getTokenAndPersist};
